import React from "react";

import { Trans, withTranslation } from "react-i18next";

import { Callout, Button } from "@blueprintjs/core";

import Title from "../Structure/logo";
import BonificationList from "./BonificationList";
import BonificationManager from "./BonificationManager";
import BonitickConnection from "./connection";


function BonificationPage() {
  const [connected, setConnected] = React.useState(false);
  const [connection, setConnection] = React.useState(false);

  React.useEffect(() => {
    const fetchData = async () => {
    }
    fetchData();
    return function () {
      //code to be run during unmount phase
      localStorage.removeItem('bonitickToken');
      localStorage.removeItem('vendorLookup');
      localStorage.removeItem('profilLookup');
      localStorage.removeItem('parkLookupDiscount');
      localStorage.removeItem('discountLookup');
    }
  }, []);

  const connectionResult = (state) => {
    setConnection(false);
    setConnected(state);
    if (state) {
      console.log('connectionResult error');
    }
  }


  return (
    <div className="component-body">
      <Title text="bonification" />
      <Callout >
        <Button
          intent="normal"
          icon={!connected ? "log-in" : "log-out"}
          onClick={() => {
            setConnection(true);
          }}
        >

          {connected ?
            <Trans>You are logged in to Bonitick back-end with an administrator account</Trans>
            :
            <Trans>Log in with an administrator account to manage discount</Trans>
          }
        </Button>
      </Callout>
      {(connected && !connection) &&
        <Callout >
          <BonificationManager />
        </Callout>
      }
      <br />
      {(!connected && !connection) &&
        <BonificationList></BonificationList>
      }
      {connection &&
        <BonitickConnection result={connectionResult}></BonitickConnection>
      }
      {/* <Title text="statistic" />
        <Callout >
            <Statistic />
        </Callout> */}
    </div>

  )
}

export default withTranslation()(BonificationPage);